/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

export type ContactResponseStatus = typeof ContactResponseStatus[keyof typeof ContactResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactResponseStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
